/**
 *
 * Transcript
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';
import { map } from 'lodash';
import QRCode from 'qrcode';

import Spinner from '@/components/Spinner.vue';
import { LOADING_MESSAGE } from './Transcript.constants';

const toFixed0 = (v) => {
  return undefined !== v && null !== v ? v.toFixed(0) : v;
};

export default {
  name: 'Transcript',

  components: {
    Spinner,
  },

  data() {
    return {
      loadingMessage: LOADING_MESSAGE,
      qrlink: '',
    };
  },

  computed: {
    ...mapState('Transcript', {
      ms_isRequest: 'isRequest',
      ms_transcript: 'transcript',
    }),

    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),

    c_transcript() {
      return {
        ...this.ms_transcript,
        bookScores: map(this.ms_transcript.bookScores, (score) => {
          let bookClass = 'progress-circle';
          bookClass += ` p${toFixed0((score.correctCount / score.totalsCount) * 100)}`;
          if ((score.correctCount / score.totalsCount) * 100 > 50) {
            bookClass += ' over50';
          }
          return {
            ...score,
            bookClass,
          };
        }),
      };
    },
  },

  filters: {
    filterToFixed0: (v) => toFixed0(v),
  },

  methods: {
    ...mapActions('Transcript', {
      ma_getPzMockPaperResult: 'getPzMockPaperResult',
    }),

    async _transcriptCreated() {
      const res = await this.ma_getPzMockPaperResult({
        paperId: this.$route.params.paperId,
      });
      let rank = 'A';
      if (res.data.data) {
        const score = res.data.data.totalScore;
        if (score >= 60) {
          rank = 'A';
        } else if (score < 60 && score >= 40) {
          rank = 'B';
        } else if (score < 40) {
          rank = 'C';
        }
      }
      let qrlink = 'https://mp.pzacademy.com/pz-wechat/share-redirect.html';
      qrlink += '?studentId=' + this.mg_userInfo.studentId + '&result=' + rank;
      this.qrlink = await QRCode.toDataURL(qrlink, { errorCorrectionLevel: 'L' });
    },
  },

  created() {
    this._transcriptCreated();
  },
};
